module.exports = __webpack_public_path__ + "img/ssd.d83a8f4b.jpg";